import { TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import DenseTable from '@src/components/Common/Table/DenseTable'
import { useTranslation } from 'react-i18next'
import { AddFeeSchemaType } from './AddFee-schema'
import FeeTableRow from './FeeTableRow'

interface FeeTableProps {
  fees: AddFeeSchemaType[]
}

const FeeTable = ({ fees }: FeeTableProps) => {
  const { t } = useTranslation()

  return (
    <DenseTable stickyHeader>
      <TableHead>
        <TableRow>
          <TableCell>{t('loan.feesDialog.feeType')}</TableCell>
          <TableCell sx={{ minWidth: 140 }}>{t('loan.feesDialog.effectiveDate')}</TableCell>
          <TableCell sx={{ minWidth: 120 }}>{t('loan.feesDialog.amount')}</TableCell>
          <TableCell>{t('loan.feesDialog.note')}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {fees.map((fee, index) => (
          <FeeTableRow key={index} fee={fee} />
        ))}
      </TableBody>
    </DenseTable>
  )
}

export default FeeTable
